var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Circle, Defs, Ellipse, G, LinearGradient, Stop } from 'react-native-svg';
export var HealthIcon = props => {
  var _props$fontSize = props.fontSize,
    fontSize = _props$fontSize === void 0 ? 24 : _props$fontSize,
    color1 = props.color1,
    color2 = props.color2,
    restProps = __rest(props, ["fontSize", "color1", "color2"]);
  var id = color1 + "_" + color2;
  return _jsxs(Svg, Object.assign({
    width: fontSize,
    height: fontSize,
    fill: "none",
    viewBox: "0 0 28 28"
  }, restProps, {
    children: [_jsxs(G, {
      children: [_jsx(Circle, {
        cx: 14,
        cy: 14.078,
        r: 4,
        fill: "url(#health_indicator_a_" + id + ")"
      }), _jsx(Circle, {
        cx: 14,
        cy: 14.078,
        r: 3.75,
        stroke: "url(#health_indicator_b_" + id + ")",
        strokeWidth: 0.5
      })]
    }), _jsx(Ellipse, {
      cx: 14,
      cy: 12.078,
      fill: "url(#health_indicator_c_" + id + ")",
      fillOpacity: 0.3,
      rx: 3,
      ry: 2
    }), _jsxs(Defs, {
      children: [_jsxs(LinearGradient, Object.assign({
        id: "health_indicator_a_" + id,
        x1: 14.597,
        x2: 14.597,
        y1: 9.434,
        y2: 18.878,
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx(Stop, {
          stopColor: color1
        }), _jsx(Stop, {
          stopColor: color2,
          offset: 1
        })]
      })), _jsxs(LinearGradient, Object.assign({
        id: "health_indicator_b_" + id,
        x1: 14,
        x2: 14,
        y1: 10.078,
        y2: 18.078,
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx(Stop, {
          stopColor: "white",
          stopOpacity: 0.65
        }), _jsx(Stop, {
          offset: 0.479,
          stopColor: "white",
          stopOpacity: 0
        })]
      })), _jsxs(LinearGradient, Object.assign({
        id: "health_indicator_c_" + id,
        x1: 14,
        x2: 14,
        y1: 10.078,
        y2: 14.078,
        gradientUnits: "userSpaceOnUse"
      }, {
        children: [_jsx(Stop, {
          stopColor: "white",
          stopOpacity: 0.2
        }), _jsx(Stop, {
          offset: 1,
          stopColor: "white"
        })]
      }))]
    })]
  }));
};